import type { Components, Theme } from '@mui/material/styles';

export const dialogTheme: Components<Theme>['MuiDialog'] = {
  styleOverrides: {
    paper: ({ theme }) => ({
      boxShadow: '0px 5px 10px 0px rgba(117, 136, 153, 0.10)',
      borderRadius: '16px',
      background: theme.vars.palette.semantic.background.base,
      minWidth: 480,
      width: 'max-content',
      display: 'flex',
      [theme.breakpoints.down('sm')]: {
        minWidth: 'unset',
        width: '100%'
      }
    }),
    paperFullScreen: {
      borderRadius: 0
    },
    paperWidthXs: {
      maxWidth: '480px'
    },
    paperWidthSm: {
      maxWidth: '480px'
    },
    paperWidthMd: {
      maxWidth: '620px'
    },
    paperWidthLg: {
      maxWidth: '820px'
    },
    paperWidthXl: {
      maxWidth: '820px'
    }
  }
};

export const dialogTitleTheme: Components<Theme>['MuiDialogTitle'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      fontSize: '18px',
      fontWeight: 500,
      color: theme.vars.palette.semantic.text.primary,
      display: 'flex',
      padding: '24px 24px 0 24px',
      justifyContent: 'space-between',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        padding: '16px 16px 0 16px'
      }
    })
  }
};

export const dialogContentTheme: Components<Theme>['MuiDialogContent'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      fontSize: '16px',
      color: theme.vars.palette.semantic.text.primary,
      padding: '24px !important',
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      overflowX: 'hidden',
      [theme.breakpoints.down('sm')]: {
        padding: '16px !important'
      }
    })
  }
};

export const dialogContentTextTheme: Components<Theme>['MuiDialogContentText'] =
  {
    styleOverrides: {
      root: ({ theme }) => ({
        padding: 'unset',
        fontSize: '16px',
        color: theme.vars.palette.semantic.text.primary
      })
    }
  };

export const dialogActionsTheme: Components<Theme>['MuiDialogActions'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: '0 24px 24px 24px',
      gap: '8px',
      '& > :not(:first-of-type)': {
        marginLeft: 0
      },
      [theme.breakpoints.down('sm')]: {
        padding: '0 16px 16px 16px'
      }
    })
  }
};
